import * as React from 'react';

import { SkeletonElement } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 1rem;
`;
const SkeletonListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
`;

export const WishlistSkeleton = () => (
  <SkeletonWrapper>
    <SkeletonElement height={5} width="100%" />
    <SkeletonListWrapper>
      <SkeletonElement height={5} width="100%" />
      <SkeletonElement height={30} width="100%" />
    </SkeletonListWrapper>
  </SkeletonWrapper>
);
